export interface BranchStatusLike {
  is_open: boolean;
  is_busy: boolean;
  reason?: string | null;
}

export function getBranchReasonLabel(reason: string | null | undefined, language: string) {
  const isArabic = language === "ar";

  switch (reason) {
    case "outside_schedule":
      return isArabic ? "خارج أوقات العمل" : "Outside working hours";
    case "temporarily_closed":
      return isArabic ? "مغلق مؤقتاً" : "Temporarily closed";
    case "manual_close":
      return isArabic ? "مغلق من الإدارة" : "Closed by management";
    default:
      return isArabic ? "الفرع غير متاح حالياً" : "Branch is unavailable right now";
  }
}

export function getClosedBranchMessage(status: BranchStatusLike | null | undefined, language: string) {
  if (!status || status.is_open) return null;

  const isArabic = language === "ar";
  const reasonLabel = getBranchReasonLabel(status.reason, language);

  return {
    title: isArabic ? "الفرع مغلق حالياً" : "This branch is currently closed",
    description: isArabic ? `سبب الإغلاق: ${reasonLabel}.` : `Reason: ${reasonLabel}.`,
  };
}
